import { Injectable } from '@angular/core';
import { TableObject } from '../../../models/tableObject';
import { NuoviInQuotazione } from '../../../models/NuoviInQuotazione';
import { ConstantsStore } from '../constants.store';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NuoveEmissioniService {

  constructor(
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  public get(
    pageNumber: number,
    pageSize: number,
    filter: string,
    ascending: boolean): Promise<TableObject<NuoviInQuotazione>> {

    return new Promise((resolve, reject) => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .toPromise()
        .then(
          (res: TableObject<NuoviInQuotazione>) => resolve(res),
          (error: any) => reject(error)
        );
    });
  }


  httpGet(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const sotto100Url = `${this.urlsStore.nuoveEmissioniUrl}/${pageNumber}/${pageSize}${this.urlsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<NuoviInQuotazione>>(sotto100Url);
  }
}
